import { Injectable } from '@angular/core';
import { GetAllocationsQuery, GetAllocationsQueryVariables, QueryResultData } from '../../../API';
import { GetAllocations } from '../../../graphql/queries';
import { ApiService } from '../../shared/services/api.service';
import { UserManagementService } from '../../shared/services/user-management.service';

@Injectable({
  providedIn: 'root',
})
export class MarketingQuotaService {
  constructor(
    private apiService: ApiService,
    private userManagementService: UserManagementService,
  ) {}

  async getAllocations(pageSize: number, pageIndex: number, searchStr: string): Promise<QueryResultData | null> {
    const orgId = this.userManagementService.getOrgId();

    if (!orgId) {
      throw new Error('Unable to load allocations: orgId is missing for the current user.');
    }

    const response = await this.apiService.query<GetAllocationsQuery, GetAllocationsQueryVariables>(GetAllocations, {
      maxRows: pageSize,
      orgId,
      pageNumber: pageIndex,
      searchStr: searchStr,
    });

    return response.data?.GetAllocations.data ?? null;
  }
}
